export default __webpack_public_path__ + "static/media/brain-gauge-logo.f7ea1d94.svg";